import Combine from './Combine/Combine';

import request from '../../Helpers/Request';

class Feeds {
    constructor(settings) {
        this.settings = settings;

        this.combine = new Combine(this.settings);
    }

    index() {
        return new Promise((resolve, reject) => {
            request('GET', '/clients/feeds', this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    download(id, params) {
        return new Promise((resolve, reject) => {
            request('GET', `/clients/feeds/${id}/download`, this.settings, null, true, params)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                reject(error);
            });
        });
    }
}

export default Feeds;
